import FreestyleState from "types/freestyle.types";
import { FreestyleReducerActions, FreestyleActionTypes } from "types/freestyle.action.types";
import config from "config";
import transformFreestyleData from "lib/transformFreestyleData";

const initialState: FreestyleState = {
  items: transformFreestyleData(config.simulations[0].freestyle.list),
  data: config.simulations[0].freestyle,
  active: false,
  contentOpened: false,
  usedPopups: []
}

export default (state = initialState, action: FreestyleReducerActions): FreestyleState => {
  const viewerApi = state.freestyleApi && state.freestyleApi!.props.viewerApi
  const remoteApi = viewerApi && viewerApi.RemoteControler
  
  switch(action.type) {
    //@ts-ignore
    case 'changeCamPos':
      const activeSim = state.data.list.find(i => i.id === state.activeItem)
    
      if(activeSim) {
        viewerApi!.goToPosition(activeSim!.campos).then(() => viewerApi!.updateFakeControlsPosition())
      }
    
      return state
    
    case FreestyleActionTypes.SET_FREESTYLE_API:
      return {
        ...state,
        freestyleApi: action.payload
      }
      
    case FreestyleActionTypes.STOP_FREESTYLE:
    
      viewerApi!.stopFreestyle()

    
      return {
        ...state,
        active: false,
        activeItem: undefined,
        contentOpened: false
      }
      
    case FreestyleActionTypes.INIT_FREESTYLE:      
      state.freestyleApi!.init()
    
      return {
        ...state,
        active: true,
        contentOpened: true
      }        
      
    case FreestyleActionTypes.TOGGLE_CONTENT_OPENED: 
      return {
        ...state,
        contentOpened: action.payload !== undefined ? action.payload : !state.contentOpened 
      }

    case FreestyleActionTypes.BUTTON_EVENT:     
      if(!state.freestyleApi!.props.viewerApi.cameraMoving && remoteApi!.enabled) {        
        const e = state.freestyleApi!.remoteEvent(action.payload)

        if(e && e.data.id !== state.activeItem) {
          const currentActiveItem = state.data.list.find(i => i.id === state.activeItem)
          
          remoteApi!.highLightButtons(e.buttons.map(item => item.name))
          state.freestyleApi!.onActiveItem(e.data, currentActiveItem ? currentActiveItem.campos : undefined)

          return {
            ...state,
            activeItem: e.data.id,
            contentOpened: state.usedPopups.includes(e.data.id) ? false : true,
            usedPopups: [...state.usedPopups, e.data.id]
          }
        }
        
        
        return {
          ...state,
          activeItem: e ? e.data.id : state.activeItem,
        }
      } else if (action.payload.type === 'up') {
        state.freestyleApi!.remoteEvent(action.payload)
      }

      return state
      
    case FreestyleActionTypes.INCREMENT_COUNTER:
      const targetAction = state.items.find(item => item.id === action.payload.id)

      if(targetAction) {
        const { current, max, min } = targetAction.counter!

        let nextValue = current + action.payload.dir 

        if(nextValue < min) nextValue = min     
        if(nextValue > max) nextValue = max     
        
        const newCounterState = {
          ...targetAction.counter!,
          current: nextValue
        }
        
        const targetViewerAction = viewerApi!.Freestyle.actions.find(item => item.props.data.id === action.payload.id)

        if(targetViewerAction) targetViewerAction.onChangeCounter(newCounterState)
        
        return {
          ...state,
          items: state.items.map(item => targetAction.id === item.id && item.counter ?
            ({
              ...item,
              counter: newCounterState
            })
            :
            item
          )
        }
      }
    
      return state

    
    default: return state
  }
}